<calsoft-template [value]="1"
 [filedName]="filedName" [filedName1]="filedName1" 
 [title]="'Home Page'" style="width: 100%;"></calsoft-template>